import React from 'react';
import { Box, BoxProps, useColorModeValue } from '@chakra-ui/react';

interface SportsCardProps extends BoxProps {
  children: React.ReactNode;
  accent?: boolean;
}

export const SportsCard: React.FC<SportsCardProps> = ({
  children,
  accent = false,
  p = { base: 4, md: 5 },
  ...rest
}) => {
  const bg = useColorModeValue('white', 'slate.850');
  const border = useColorModeValue('gray.200', 'gray.700');
  const accentBorder = useColorModeValue('pitch.500', 'pitch.400');

  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={accent ? accentBorder : border}
      borderLeftWidth={accent ? '4px' : '1px'}
      borderRadius="lg"
      p={p}
      boxShadow="sm"
      {...rest}
    >
      {children}
    </Box>
  );
};
